function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable max-len */
import { between } from 'airbnb-prop-types';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../Button';
import { ExtraSmall, LargerThanExtraSmall } from '../Responsive';
import getTextFromElement from '../utils/getTextFromElement';
import Icon from '../Icon';
import newId from '../utils/newId';

var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this, props));
    _this.previousButtonRef = null;
    _this.nextButtonRef = null;
    _this.pageRefs = {};
    _this.state = {
      currentPage: _this.props.currentPage,
      pageButtonSelected: false
    };
    return _this;
  }

  _createClass(Pagination, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.currentPage !== this.props.currentPage || nextProps.currentPage !== this.state.currentPage) {
        this.setState({
          currentPage: nextProps.currentPage
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      // Update only when the props and currentPage state changes to avoid re-render
      // if only the pageButtonSelected state is changed.
      return nextProps !== this.props || nextState.currentPage !== this.state.currentPage;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state = this.state,
          currentPage = _this$state.currentPage,
          pageButtonSelected = _this$state.pageButtonSelected;
      var currentPageRef = this.pageRefs[currentPage];

      if (currentPageRef && pageButtonSelected) {
        currentPageRef.focus();
        this.setPageButtonSelectedState(false);
      }
    }
  }, {
    key: "setPageButtonSelectedState",
    value: function setPageButtonSelectedState(value) {
      this.setState({
        pageButtonSelected: value
      });
    }
  }, {
    key: "handlePageSelect",
    value: function handlePageSelect(page) {
      if (page !== this.state.currentPage) {
        this.setState({
          currentPage: page,
          pageButtonSelected: true
        });
        this.props.onPageSelect(page);
      }
    }
  }, {
    key: "handlePreviousNextButtonClick",
    value: function handlePreviousNextButtonClick(page) {
      var pageCount = this.props.pageCount;

      if (page === 1) {
        this.nextButtonRef.focus();
      } else if (page === pageCount) {
        this.previousButtonRef.focus();
      }

      this.setState({
        currentPage: page
      });
      this.props.onPageSelect(page);
    }
  }, {
    key: "renderEllipsisButton",
    value: function renderEllipsisButton() {
      return React.createElement("li", {
        className: classNames(['page-item', 'disabled']),
        key: newId('pagination-ellipsis-')
      }, React.createElement("span", {
        className: classNames(['btn', 'page-link', 'ml-0', 'border-0'])
      }, "..."));
    }
  }, {
    key: "renderPageButton",
    value: function renderPageButton(page) {
      var _this2 = this;

      var buttonLabels = this.props.buttonLabels;
      var active = page === this.state.currentPage || null;
      var ariaLabel = getTextFromElement(React.createElement("div", null, buttonLabels.page, " ".concat(page), active && React.createElement("span", null, ', ', buttonLabels.currentPage)));
      return React.createElement("li", {
        className: classNames(['page-item', {
          active: active
        }]),
        key: page
      }, React.createElement(Button, {
        className: "page-link",
        "aria-label": ariaLabel,
        inputRef: function inputRef(element) {
          _this2.pageRefs[page] = element;
        },
        onClick: function onClick() {
          _this2.handlePageSelect(page);
        }
      }, page.toString()));
    }
  }, {
    key: "renderPageOfCountButton",
    value: function renderPageOfCountButton() {
      var currentPage = this.state.currentPage;
      var _this$props = this.props,
          pageCount = _this$props.pageCount,
          buttonLabels = _this$props.buttonLabels;
      var ariaLabel = getTextFromElement(React.createElement("div", null, buttonLabels.page, " ".concat(currentPage, ", "), buttonLabels.currentPage, ', ', buttonLabels.pageOfCount, " ".concat(pageCount)));
      var label = React.createElement("span", null, "".concat(currentPage, " "), buttonLabels.pageOfCount, " ".concat(pageCount));
      return React.createElement("li", {
        className: classNames(['page-item', 'disabled']),
        key: currentPage
      }, React.createElement("span", {
        className: classNames(['btn', 'page-link', 'mx-2', 'border-0']),
        "aria-label": ariaLabel
      }, label));
    }
  }, {
    key: "renderPreviousButton",
    value: function renderPreviousButton() {
      var _this3 = this;

      var buttonLabels = this.props.buttonLabels;
      var currentPage = this.state.currentPage;
      var isFirstPage = currentPage === 1;
      var previousPage = isFirstPage ? null : currentPage - 1;
      var ariaLabel = getTextFromElement(React.createElement("div", null, buttonLabels.previous, previousPage && React.createElement("span", null, ', ', buttonLabels.page, " ".concat(previousPage))));
      return React.createElement("li", {
        className: classNames('page-item', {
          disabled: isFirstPage
        })
      }, React.createElement(Button, {
        className: "previous page-link",
        "aria-label": ariaLabel,
        tabIndex: isFirstPage ? '-1' : undefined,
        onClick: function onClick() {
          _this3.handlePreviousNextButtonClick(previousPage);
        },
        inputRef: function inputRef(element) {
          _this3.previousButtonRef = element;
        },
        disabled: isFirstPage
      }, React.createElement("div", null, React.createElement(Icon, {
        id: newId('pagination-'),
        className: "fa fa-chevron-left mr-2"
      }), buttonLabels.previous)));
    }
  }, {
    key: "renderNextButton",
    value: function renderNextButton() {
      var _this4 = this;

      var _this$props2 = this.props,
          buttonLabels = _this$props2.buttonLabels,
          pageCount = _this$props2.pageCount;
      var currentPage = this.state.currentPage;
      var isLastPage = currentPage === pageCount;
      var nextPage = isLastPage ? null : currentPage + 1;
      var ariaLabel = getTextFromElement(React.createElement("div", null, buttonLabels.next, nextPage && React.createElement("span", null, ', ', buttonLabels.page, " ".concat(nextPage))));
      return React.createElement("li", {
        className: classNames('page-item', {
          disabled: isLastPage
        })
      }, React.createElement(Button, {
        className: "next page-link",
        "aria-label": ariaLabel,
        tabIndex: isLastPage ? '-1' : undefined,
        onClick: function onClick() {
          _this4.handlePreviousNextButtonClick(nextPage);
        },
        inputRef: function inputRef(element) {
          _this4.nextButtonRef = element;
        },
        disabled: isLastPage
      }, React.createElement("div", null, buttonLabels.next, React.createElement(Icon, {
        id: newId('pagination-'),
        className: "fa fa-chevron-right ml-2"
      }))));
    }
  }, {
    key: "renderScreenReaderSection",
    value: function renderScreenReaderSection() {
      var currentPage = this.state.currentPage;
      var _this$props3 = this.props,
          buttonLabels = _this$props3.buttonLabels,
          pageCount = _this$props3.pageCount;
      return React.createElement("div", {
        className: "sr-only",
        "aria-live": "polite",
        "aria-relevant": "text",
        "aria-atomic": true
      }, getTextFromElement(React.createElement("div", null, buttonLabels.page, " ".concat(currentPage, ", "), buttonLabels.currentPage, ', ', buttonLabels.pageOfCount, " ".concat(pageCount))));
    }
    /*
     * Uses recursion to generate an array of the buttons to display (i.e., page/ellipsis
     * buttons) given the currently selected page, the max number of buttons to display, and
     * the total number of pages.
     */

  }, {
    key: "renderPageButtons",
    value: function renderPageButtons(range) {
      var _this5 = this;

      var currentPage = this.state.currentPage;
      var _this$props4 = this.props,
          pageCount = _this$props4.pageCount,
          maxPagesDisplayed = _this$props4.maxPagesDisplayed;

      var pageRange = range || _toConsumableArray(Array(pageCount).keys()).map(function (page) {
        return page + 1;
      });

      var currentIndex = pageRange.indexOf(currentPage);
      var middleIndex = parseInt(pageRange.length / 2, 10) - 1;
      var lastIndex = pageRange.length - 1;
      var hasLeftEllipsis = pageRange[1] - pageRange[0] > 1;
      var hasRightEllipsis = pageRange[lastIndex] - pageRange[lastIndex - 1] > 1;
      var ellipsisCount = 0;
      ellipsisCount += hasLeftEllipsis;
      ellipsisCount += hasRightEllipsis;

      if (pageRange.length <= maxPagesDisplayed - ellipsisCount) {
        return pageRange.map(function (page) {
          var pageButtons = [_this5.renderPageButton(page)];

          if (page === 1 && hasLeftEllipsis) {
            pageButtons.push(_this5.renderEllipsisButton());
          } else if (page === pageCount && hasRightEllipsis) {
            pageButtons.unshift(_this5.renderEllipsisButton());
          }

          return pageButtons;
        });
      }

      if (currentIndex > middleIndex) {
        var first = pageRange.shift();
        pageRange.shift();
        pageRange.unshift(first);
      } else {
        var last = pageRange.pop();
        pageRange.pop();
        pageRange.push(last);
      }

      return this.renderPageButtons(pageRange);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("nav", {
        "aria-label": this.props.paginationLabel,
        className: this.props.className
      }, this.renderScreenReaderSection(), React.createElement("ul", {
        className: "pagination"
      }, this.renderPreviousButton(), React.createElement(ExtraSmall, null, this.renderPageOfCountButton()), React.createElement(LargerThanExtraSmall, null, this.renderPageButtons()), this.renderNextButton()));
    }
  }]);

  return Pagination;
}(React.Component);

Pagination.defaultProps = {
  buttonLabels: {
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    currentPage: 'Current Page',
    pageOfCount: 'of'
  },
  className: undefined,
  currentPage: 1,
  maxPagesDisplayed: 7
};
Pagination.propTypes = {
  /** specifies a callback function that is executed when the user selects a page button or the `Previous`/`Next` buttons. For example:
  ```jsx
  <Pagination onPageSelect={(pageNumber) => { console.log(pageNumber); } />
  ``` */
  onPageSelect: PropTypes.func.isRequired,

  /** specifies the total number of pages in the `Pagination` component. */
  pageCount: PropTypes.number.isRequired,

  /** specifies the `aria-label` for the `<nav>` element that wraps the pagination button list. */
  paginationLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,

  /** specifies the labels to use for the `Previous`/`Next` buttons as well as the various parts of `aria-label` on the page buttons for accessibility. All button labels accept both string or elements. The button label options are as follows:
  * `previous`: Text for the `Previous` button;
  * `next`: Text for the `Next` button;
  * `page`: Text in the `aria-label` on page buttons to describe the button (e.g., "**Page** 1");
  * `currentPage`: Text to depict the selected page in the `aria-label`
  on page buttons (e.g., "Page 1, **Current Page**");
  * `pageOfCount`: Text that separates the current page and total page count
  for the mobile UI (e.g., "Page 1 **of** 20").
  The default is:
  ```javascript
  {
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    currentPage: 'Current Page',
    pageOfCount: 'of',
  }
  ``` */
  buttonLabels: PropTypes.shape({
    previous: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    next: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    page: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    currentPage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    pageOfCount: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  }),

  /** specifies any class name(s) for the `Pagination` component. The default is an empty string. */
  className: PropTypes.string,

  /** specifies the page that the `Pagination` component will automatically select. The default is `1`. */
  currentPage: PropTypes.number,

  /** specifies the number of page buttons to display in between the `Previous` and `Next` buttons. This number also includes any ellipses in the total count. Also, to ensure that at least one clickable page button is shown when both ellipses are displayed, this value must be greater than `4`.  The default is `7`. */
  maxPagesDisplayed: between({
    gt: 4
  })
};
export default Pagination;
//# sourceMappingURL=index.js.map